module.exports = __webpack_public_path__ + "assets/start.png?ec4c246f7e567d7f538313640f834304";